import { ActivitiesRoutingModule } from './activities-routing.module';
import { NgModule } from '@angular/core';
import { NgxMaskModule } from 'ngx-mask';

import { SharedModule } from '@tech-utils/shared.module';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { ActivitiesComponent } from './activities.component';
import { ModalOrderComponent } from './modal-order/modal-order.component';
import { ModalPartialdepositComponent } from './modal-partialdeposit/modal-partialdeposit.component';
import { ModalPartialwithdrawalComponent } from './modal-partialwithdrawal/modal-partialwithdrawal.component';
import { ModalTabledetailComponent } from './modal-tabledetail/modal-tabledetail.component';
import { PruebaComponent } from './prueba/prueba.component';
import { ClipboardModule } from '@angular/cdk/clipboard';

const APP_COMPONENTS = [
  ActivitiesComponent,
  ModalOrderComponent,
  ModalPartialdepositComponent,
  ModalPartialwithdrawalComponent,
  ModalTabledetailComponent,
  PruebaComponent,
];

const APP_IMPORTS = [
  SharedModule,
  NgxMaskModule,

  PickerModule,
  ClipboardModule,
  ActivitiesRoutingModule,
];

@NgModule({
  declarations: [APP_COMPONENTS],
  imports: APP_IMPORTS,
  exports: [APP_COMPONENTS],
})
export class ActivitiesModule {}
